module.exports = __webpack_public_path__ + "static/media/released.2eaf2a10.svg";